module.exports = {
      id: "kishoralo-white-usage",
      viewBox: "0 0 625 349",
      url: "/" + "sprite-819208feb9a4c8de23db7726a2e05315.svg#kishoralo-white",
      toString: function () {
        return this.url;
      }
    }